import Vue from 'vue'
import Terms from '../Terms.js'

var HttpRequest = function (context, method, url, options) {
    this.context = context;
    this.method = method;
    this.url = url;
    this.options = options;

    this.promise = new Promise((resolve, reject) => {
        this._resolve = resolve;
        this._reject = reject;
    });
};

HttpRequest.prototype.then = function (onSuccess, onError) {
    this.promise = this.promise.then(response => {
        return onSuccess.call(this.context, response);
    });

    this.promise = this.promise.catch(response => {
        if (onError) {
            return onError.call(this.context, response);
        }
        return response;
    });

    return this.promise;
};

var HttpDataRequest = function (context, method, url, data, options) {
    this.context = context;
    this.method = method;
    this.url = url;
    this.data = data;
    this.options = options;

    this.promise = new Promise((resolve, reject) => {
        this._resolve = resolve;
        this._reject = reject;
    });
};

HttpDataRequest.prototype.then = function (onSuccess, onError) {
    this.promise = this.promise.then(response => {
        return onSuccess.call(this.context, response);
    });

    this.promise = this.promise.catch(response => {
        if (onError) {
            return onError.call(this.context, response);
        }
        return response;
    });

    return this.promise;
};

var HttpBatch = function (context) {
    this.context = context;
    this.buffer = [];
    this.data_buffer = [];

    this.promise = new Promise((resolve, reject) => {
        this._resolve = resolve;
        this._reject = reject;
    });
};
HttpBatch.prototype.get = function (url, options) {
    var request = new HttpRequest(this.context, 'get', url, options);
    this.buffer.push(request);
    return request;
};
HttpBatch.prototype.delete = function (url, options) {
    var request = new HttpRequest(this.context, 'delete', url, options);
    this.buffer.push(request);
    return request;
};
HttpBatch.prototype.post = function (url, data, options) {
    var request = new HttpDataRequest(this.context, 'post', url, data, options);
    this.data_buffer.push(request);
    return request;
};
HttpBatch.prototype.put = function (url, data, options) {
    var request = new HttpDataRequest(this.context, 'put', url, data, options);
    this.data_buffer.push(request);
    return request;
};
HttpBatch.prototype.patch = function (url, data, options) {
    var request = new HttpDataRequest(this.context, 'patch', url, data, options);
    this.data_buffer.push(request);
    return request;
};
HttpBatch.prototype.then = function (onSuccess, onError) {
    this.promise = this.promise.then(response => {
        return onSuccess.call(this.context, response);
    });

    this.promise = this.promise.catch(response => {
        if (onError) {
            return onError.call(this.context, response);
        }
        return response;
    });

    return this.promise;
};
HttpBatch.prototype.load = function () {
    batches.push(this);
    flush();
};

let isValidToken = true;
let isLoadingToken = false;
let token = null;

let buffer = [];
let data_buffer = [];
let batches = [];

function hasToken() {
    return !isLoadingToken && isValidToken;
}

function flush() {
    // Check if a token exists
    if (token == null) {
        loadToken();
        return;
    }

    // Make sure we have a token, and that token is valid
    if (!hasToken()) {
        return;
    }

    while (buffer.length > 0 && hasToken()) {
        const r = buffer.pop();
        Vue.http[r.method](r.url, r.options).then(function (request, response) {
                request._resolve.call(this, response); // Start supporting Promise api in requests
            }.bind(r.context, r),
            function (request, response) {

                let has_token_expired = handleTokenErrors(response);
                if (has_token_expired) {
                    buffer.push(request);
                }
                else
                {
                    request._reject.call(this, response); // Start supporting Promise api in requests
                }
            }.bind(r.context, r));
    }

    while (data_buffer.length > 0 && hasToken()) {
        const r = data_buffer.pop();
        Vue.http[r.method](r.url, r.data, r.options).then(function (request, response) {
                r._resolve.call(this, response); // Start supporting Promise api in requests
            }.bind(r.context, r),
            function (request, response) {

                let has_token_expired = handleTokenErrors(response);
                if (has_token_expired) {
                    data_buffer.push(request);
                }
                else
                {
                    r._reject.call(this, response); // Start supporting Promise api in requests
                }
            }.bind(r.context, r));
    }

    while (batches.length > 0 && hasToken()) {
        const batch = batches.pop();

        var requests_array = [];
        var request_map = [];

        for (var index = 0; index < batch.buffer.length; index++) {
            const r = batch.buffer[index];
            requests_array.push({
                url: r.url,
                method: r.method
            });
            request_map.push(r);
        }
        for (var index = 0; index < batch.data_buffer.length; index++) {
            const r = batch.data_buffer[index];
            requests_array.push({
                url: r.url,
                method: r.method,
                body: r.data
            });
            request_map.push(r);
        }

        Vue.http.post('batch', requests_array).then(function (batch, responses) {
            for (var index = 0; index < responses.data.length; index++) {
                var response = responses.data[index];
                var response_object = {
                    url: response.url,
                    status: response.code,
                    data: response.body
                };

                if(typeof request_map[index] !== 'undefined' && request_map[index] !== null){
                    request_map[index]._resolve.call(this, response_object); // Start supporting Promise api in requests
                }else{
                    console.error('#2025 Batch responses does not match requests');
                }
            }

            batch._resolve.call(this, responses); // Start supporting Promise api in requests
        }.bind(batch.context, batch),
        function (batch, response) {

            let has_token_expired = handleTokenErrors(response);
            if (has_token_expired) {
                batches.push(batch);
            }
            else {
                for (var index = 0; index < batch.buffer.length; index++) {
                    var r = batch.buffer[index];

                    r._reject.call(this, response); // Start supporting Promise api in requests
                }
                for (var index = 0; index < batch.data_buffer.length; index++) {
                    var r = batch.data_buffer[index];

                    r._reject.call(this, response); // Start supporting Promise api in requests
                }

                batch._reject.call(this, response); // Start supporting Promise api in requests
            }
        }.bind(batch.context, batch));
    }
};


function loadToken(callback) {
    if (!isLoadingToken) {
        isLoadingToken = true;

        Vue.http.get('token').then(function (response) {

            handleTokenSuccess(callback, response);
        }, function (response) {
            // #2305 fix - social logins need to recheck the token, otherwise gets a 400 error for some reason. Resending the request seems to fix that
            handleTokenLoginFail(callback);
        });
    }
};

function handleTokenSuccess(callback, response) {
    if (response.status == 200) {
        token = response.data.token;
        localStorage.setItem('token', JSON.stringify(token));
        window.localStorage.removeItem('tokenized');
        isLoadingToken = false;
        window.token_loaded = true;

        window.currentInstance.$events.emit('auth.token.set', token);
        flush();

        // #2980 Redirect new authorized users to the terms page.
        Terms.redirectToTerms(response);
    }
    // #446 Call back after the token was refreshed. Pass the status.
    if (callback == 'function') {
        callback(response.status);
    }
}
function handleTokenLoginFail(callback) {
    Vue.http.get('token').then(function (response) {
      handleTokenSuccess(callback, response);
    }, function (response) {
      // #446.
      // Avoid looping.
      if (callback == 'stop' && !mustLogOut(response)) {
        return false;
      }
      handleTokenErrors(response);
      if(window.localStorage.getItem('tokenized') == null
        && window.localStorage.getItem('token') != null) {
        if(window.location.pathname == "/users/login") {
            window.localStorage.removeItem('token');
        } else {
            window.localStorage.setItem('tokenized', false);
            window.location = '/tokenized';
        }
      } else if(window.localStorage.getItem('tokenized') == "false"
        && window.localStorage.getItem('token') != null
        && window.location.pathname.indexOf('tokenized') == -1) {
        window.localStorage.removeItem('token');

        let orgpage = window.localStorage.getItem('orgpage')
        if (orgpage !== null) {
            orgpage = JSON.parse(orgpage).value
        }
        const isFromOrgPage = (typeof orgpage === 'string' && orgpage.length > 0);
        const redirect = (isFromOrgPage) ? '/' + orgpage : '/users/login'

        window.location.href = '/users/logout?redirect=' + redirect + '?error=login.session_expired_error';
      }
    });
}

// 5xx errors -  Something has went really wrong with the server or token.
// https://en.wikipedia.org/wiki/List_of_HTTP_status_codes#5xx_Server_error
// 500: 'Token has expired and can no longer be refreshed' when JWT 'refresh_ttl' has expired.
// 401 or 403: 'The token has been blacklisted'.
function mustLogOut(response) {

		let returnVal = false;
        const error_group = response.status / 100;

		// #3314 Log-out if is in a dashboard and doesn't have a token. This is to
		// avoid the broken dashboard that happens when a session on PHP side is active
		// but not on the front-side (token is missing).
		if(window.location.pathname.indexOf("/dashboard")  !== -1) {
			if(error_group == 5){
					returnVal = true;
			}

			switch(response.data.message){
					case 'The token has been blacklisted':
					case 'The token is invalid':
					case 'Token not provided':
							returnVal = true;
			}
		}
		// #3314 Allow to logout from pages that does not have "/dashboard" part in it's URL.
		// This is for the case when the logout did not happen in a dashboard because
		// a redirect to another page happened first.
		if(localStorage.getItem('must_logout') !== null){
			returnVal = true;
		}

		if(returnVal){
			localStorage.setItem('must_logout', 1);
		}

    return returnVal;
}

function logOut() {

    // Remove the invalid token and ask to login.
    localStorage.removeItem('token');
		localStorage.removeItem('must_logout')

    // Redirect to logout instead of login to avoid redirect to dashboard (if is logged in).
    window.location.replace("/logout");
}


function handleTokenErrors(response) {

    let has_token_expired = false;
    let token_message = false;
    let token_error = false;

    if (response === undefined || response === null)
    {
        return has_token_expired;
    }

    if (typeof response.data !== "undefined" && response.data !== null) {
        token_message = typeof response.data.message !== 'undefined' && response.data.message == 'Token expired';
        token_error = typeof response.data.error !== 'undefined' && response.data.error == 'token_expired';
    }

    if (mustLogOut(response)) {
        logOut();
    }
    // Probably nothing so serious. Expired or blacklisted token.
    // 401: 'token_expired' when JWT 'ttl' has expired.
    else if (response.status == 401 && (token_message || token_error)) {

        // Try to reload once more and the stop.
        loadToken('stop');
        has_token_expired = true;
    }

    return has_token_expired;
}

function get(context, url, options) {
    var request = new HttpRequest(context, 'get', url, options);
    buffer.push(request);
    flush();
    return request;
};

function _delete(context, url, options) {
    var request = new HttpRequest(context, 'delete', url, options);
    buffer.push(request);
    flush();
    return request;
};

function post(context, url, data, options) {
    var request = new HttpDataRequest(context, 'post', url, data, options);
    data_buffer.push(request);
    flush();
    return request;
};

function put(context, url, data, options) {
    var request = new HttpDataRequest(context, 'put', url, data, options);
    data_buffer.push(request);
    flush();
    return request;
};

function patch(context, url, data, options) {
    var request = new HttpDataRequest(context, 'patch', url, data, options);
    data_buffer.push(request);
    flush();
    return request;
};

function batch(context) {
    var batcher = new HttpBatch(context);
    return batcher;
}

export default {
    flush,
    loadToken,
    get,
    delete: _delete,
    post,
    put,
    patch,
    batch,
    handleTokenErrors
};
